export class AloUploadResult {
    
    public typ:ApiBinaryFileType
    public name:string
    public url:string
    public fileSize:number

    constructor({typ,name,url,fileSize}:{typ:number,name:string,url:string,fileSize:number}) {
        this.typ = typ
        this.name = name        
        this.url = url
        this.fileSize = fileSize
    }      
    
    static createAloUploadResult(data:any) {
        return new AloUploadResult(data)
    }
}

export enum ApiBinaryFileType {
    graphimage = 1,
    publicimage = 2
}